<template>
	<LayoutOffcanvasStandard ref="offcanvas" :title="(selecteds.quantity == 1) ? 'Agrupar cliente' : `Agrupar los ${selecteds.quantity} clientes`" id="company-admin-customer-group">
		<template #body>
			<ul class="list-group list-group-flush rounded-4">
				<template v-if="groups.length > 0">
					<li class="list-group-item px-0 py-3 lh-sm hstack gap-1" v-for="group in groups" :key="group.id">
						<div class="vstack">
							<a href="javascript:void(0);" class="fw-bold link-dark stretched-link" @click="submit(group.id);">{{ group.name }}</a>
							<small class="d-block fw-normal">{{ (group.customers_count == 0) ? 'Sin clientes agrupados' : ((group.customers_count == 1) ? '1 cliente agrupado' : `${group.customers_count} clientes agrupados`) }}</small>
						</div>
						<i class="bi bi-chevron-right text-xl"></i>
					</li>
				</template>
				<template v-else>
					<li class="list-group-item px-0 py-3 lh-sm">
						No se encontraron grupos.
					</li>
				</template>
			</ul>
			<CommonMessageInfo info="Selecciona el grupo para asignar los clientes." />
		</template>
		<template #footer>
			<button type="button" class="btn rounded-pill btn-danger" :disabled="submitting" @click="ungroup">Desagrupar clientes</button>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref } from 'vue';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CompanyAdminGroupRepository from '@/repositories/modules/Company/Admin/Group';
	import CompanyAdminCustomerRepository from '@/repositories/modules/Company/Admin/Customer';

	export default {
		emits: ['unselect', 'reload'],
		props: {
			selecteds: Object,
			filters: Object,
			groups: Array
		},
		setup(props, { emit }) {
			const { submitting, catchError } = composableForm();
			const offcanvas = ref(null);

			const unselect = async () => {
				emit('unselect');
				offcanvas.value.offcanvas.hide();
			}

			const submit = async (id) => {
				if(submitting.value) return;
				submitting.value = true;

				var data = _.clone(props.filters);
				data.selection = {
					selecteds: props.selecteds,
					group_id: id
				}

				await CompanyAdminCustomerRepository.group(data).then(finish).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			const ungroup = async (id) => {
				if(submitting.value) return;
				submitting.value = true;

				var data = _.clone(props.filters);
				data.selection = {
					selecteds: props.selecteds,
					group_id: id
				}

				await CompanyAdminCustomerRepository.ungroup(data).then(finish).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			const finish = () => {
				emit('unselect');
				emit('reload');
				offcanvas.value.offcanvas.hide();
			}

			const show = () => {
				offcanvas.value.offcanvas.show();
			}

			return { offcanvas, unselect, submit, ungroup, show, submitting };
		}
	}
</script>